export const blogs1 = [
  {
    id: 1,
    imgSrc: "/assets/images/home/demo2/post1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 2,
    imgSrc: "/assets/images/home/demo2/post2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
  },
  {
    id: 3,
    imgSrc: "/assets/images/home/demo2/post3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
  },
  {
    id: 4,
    imgSrc: "/assets/images/home/demo2/post2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
  },
];

export const blogs2 = [
  {
    id: 5,
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    imgSrc: "/assets/images/home/demo4/post-1.jpg",
  },
  {
    id: 6,
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
    imgSrc: "/assets/images/home/demo4/post-2.jpg",
  },
  {
    id: 7,
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
    imgSrc: "/assets/images/home/demo4/post-3.jpg",
  },
  {
    id: 8,
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    imgSrc: "/assets/images/home/demo4/post-4.jpg",
  },
  {
    id: 9,
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    imgSrc: "/assets/images/home/demo4/post-1.jpg",
  },
  {
    id: 10,
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
    imgSrc: "/assets/images/home/demo4/post-2.jpg",
  },
  {
    id: 11,
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
    imgSrc: "/assets/images/home/demo4/post-3.jpg",
  },
  {
    id: 12,
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    imgSrc: "/assets/images/home/demo4/post-4.jpg",
  },
];
export const blogs3 = [
  {
    id: 13,
    imgSrc: "/assets/images/home/demo9/post1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 14,
    imgSrc: "/assets/images/home/demo9/post2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
  },
  {
    id: 15,
    imgSrc: "/assets/images/home/demo9/post3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
  },
  {
    id: 16,
    imgSrc: "/assets/images/home/demo9/post1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 17,
    imgSrc: "/assets/images/home/demo9/post2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
  },
  {
    id: 18,
    imgSrc: "/assets/images/home/demo9/post3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
  },
];

export const blogs4 = [
  {
    id: 19,
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    imgSrc: "/assets/images/home/demo10/post1.jpg",
    width: 450,
    height: 300,
  },
  {
    id: 20,
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
    imgSrc: "/assets/images/home/demo10/post2.jpg",
    width: 450,
    height: 300,
  },
  {
    id: 21,
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
    imgSrc: "/assets/images/home/demo10/post3.jpg",
    width: 450,
    height: 300,
  },
  {
    id: 22,
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    imgSrc: "/assets/images/home/demo10/post1.jpg",
    width: 450,
    height: 300,
  },
  {
    id: 23,
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
    imgSrc: "/assets/images/home/demo10/post2.jpg",
    width: 450,
    height: 300,
  },
  {
    id: 24,
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
    imgSrc: "/assets/images/home/demo10/post3.jpg",
    width: 450,
    height: 300,
  },
];

export const blogs5 = [
  {
    id: 25,
    imgSrc: "/assets/images/home/demo12/post-1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 26,
    imgSrc: "/assets/images/home/demo12/post-2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
  },
  {
    id: 27,
    imgSrc: "/assets/images/home/demo12/post-3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
  },
  {
    id: 28,
    imgSrc: "/assets/images/home/demo12/post-4.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 29,
    imgSrc: "/assets/images/home/demo12/post-1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 30,
    imgSrc: "/assets/images/home/demo12/post-2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
  },
  {
    id: 31,
    imgSrc: "/assets/images/home/demo12/post-3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
  },
  {
    id: 32,
    imgSrc: "/assets/images/home/demo12/post-4.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
];

export const blogs6 = [
  {
    id: 33,
    imgSrc: "/assets/images/home/demo14/blog-1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 34,
    imgSrc: "/assets/images/home/demo14/blog-2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
  },
  {
    id: 35,
    imgSrc: "/assets/images/home/demo14/blog-3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
  },
  {
    id: 36,
    imgSrc: "/assets/images/home/demo14/blog-1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 37,
    imgSrc: "/assets/images/home/demo14/blog-2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "What Freud Can Teach Us About Furniture",
  },
  {
    id: 38,
    imgSrc: "/assets/images/home/demo14/blog-3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Habitant morbi tristique senectus",
  },
];
export const blogs7 = [
  {
    id: 39,
    imgSrc: "/assets/images/home/demo15/blog-1.jpg",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    author: "Admin",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 40,
    imgSrc: "/assets/images/home/demo15/blog-2.jpg",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    author: "Admin",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 41,
    imgSrc: "/assets/images/home/demo15/blog-3.jpg",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    author: "Admin",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 42,
    imgSrc: "/assets/images/home/demo15/blog-4.jpg",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    author: "Admin",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 43,
    imgSrc: "/assets/images/home/demo15/blog-1.jpg",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    author: "Admin",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 44,
    imgSrc: "/assets/images/home/demo15/blog-2.jpg",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    author: "Admin",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 45,
    imgSrc: "/assets/images/home/demo15/blog-3.jpg",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    author: "Admin",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 46,
    imgSrc: "/assets/images/home/demo15/blog-4.jpg",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    author: "Admin",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
];
export const blogs8 = [
  {
    id: 47,
    imgSrc: "/assets/images/home/demo16/blog-1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 48,
    imgSrc: "/assets/images/home/demo16/blog-2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 49,
    imgSrc: "/assets/images/home/demo16/blog-3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 50,
    imgSrc: "/assets/images/home/demo16/blog-1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 51,
    imgSrc: "/assets/images/home/demo16/blog-2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
  {
    id: 52,
    imgSrc: "/assets/images/home/demo16/blog-3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
  },
];

export const blogs9 = [
  {
    id: 53,
    date: "April 05, 2023",
    commentCount: 12,
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
    imgSrc: "/assets/images/home/demo18/blog-1.jpg",
  },
  {
    id: 54,
    date: "April 05, 2023",
    commentCount: 12,
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
    imgSrc: "/assets/images/home/demo18/blog-2.jpg",
  },
  {
    id: 55,
    date: "April 05, 2023",
    commentCount: 12,
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
    imgSrc: "/assets/images/home/demo18/blog-3.jpg",
  },
  {
    id: 56,
    date: "April 05, 2023",
    commentCount: 12,
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
    imgSrc: "/assets/images/home/demo18/blog-4.jpg",
  },
  {
    id: 57,
    date: "April 05, 2023",
    commentCount: 12,
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
    imgSrc: "/assets/images/home/demo18/blog-1.jpg",
  },
  {
    id: 58,
    date: "April 05, 2023",
    commentCount: 12,
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
    imgSrc: "/assets/images/home/demo18/blog-2.jpg",
  },
  {
    id: 59,
    date: "April 05, 2023",
    commentCount: 12,
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
    imgSrc: "/assets/images/home/demo18/blog-3.jpg",
  },
  {
    id: 60,
    date: "April 05, 2023",
    commentCount: 12,
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
    imgSrc: "/assets/images/home/demo18/blog-4.jpg",
  },
];

export const blogs10 = [
  {
    id: 61,
    imgSrc: "/assets/images/home/demo19/blog-1.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 62,
    imgSrc: "/assets/images/home/demo19/blog-2.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 63,
    imgSrc: "/assets/images/home/demo19/blog-3.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
  {
    id: 64,
    imgSrc: "/assets/images/home/demo19/blog-4.jpg",
    author: "Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    content:
      "Est Diam Debitis An, Error Recusabo Id Pro, Quo Eripuit Civibus Ut.",
  },
];

export const blogs11 = [
  {
    id: 65,
    imgSrc: "/assets/images/home/demo22/blog-1.jpg",
    date: "April 05, 2023",
    comments: "12 Comment",
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
  },
  {
    id: 66,
    imgSrc: "/assets/images/home/demo22/blog-2.jpg",
    date: "April 05, 2023",
    comments: "12 Comment",
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
  },
  {
    id: 67,
    imgSrc: "/assets/images/home/demo22/blog-3.jpg",
    date: "April 05, 2023",
    comments: "12 Comment",
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
  },
  {
    id: 68,
    imgSrc: "/assets/images/home/demo22/blog-4.jpg",
    date: "April 05, 2023",
    comments: "12 Comment",
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
  },
  {
    id: 69,
    imgSrc: "/assets/images/home/demo22/blog-1.jpg",
    date: "April 05, 2023",
    comments: "12 Comment",
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
  },
  {
    id: 70,
    imgSrc: "/assets/images/home/demo22/blog-2.jpg",
    date: "April 05, 2023",
    comments: "12 Comment",
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
  },
  {
    id: 71,
    imgSrc: "/assets/images/home/demo22/blog-3.jpg",
    date: "April 05, 2023",
    comments: "12 Comment",
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
  },
  {
    id: 72,
    imgSrc: "/assets/images/home/demo22/blog-4.jpg",
    date: "April 05, 2023",
    comments: "12 Comment",
    title: "Attract Sales And Profits",
    content:
      "A job ravenously while Far much that one rank beheld after outside....",
  },
];

export const blogs12 = [
  {
    id: 73,
    imgSrc: "/assets/images/blog/blog-1.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["FASHION", "STYLE"],
  },

  {
    id: 74,
    imgSrc: "/assets/images/blog/blog-2.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "5 Tips to Increase Your Online Sales",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["COMPANY", "TRENDS"],
  },

  {
    id: 75,
    imgSrc: "/assets/images/blog/blog-3.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Tree earth fowl given moveth deep lesser After",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["FASHION", "STYLE"],
  },

  {
    id: 76,
    imgSrc: "/assets/images/blog/blog-4.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Given Set was without from god divide rule Hath",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["COMPANY", "BEAUTY"],
  },
];

export const blogs13 = [
  {
    id: 77,
    imgSrc: "/assets/images/blog/blog-5.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["STYLE", "BEAUTY"],
  },
  {
    id: 78,
    imgSrc: "/assets/images/blog/blog-6.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Heaven upon heaven moveth every have.",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["FASHION", "TRENDS"],
  },
  {
    id: 79,
    imgSrc: "/assets/images/blog/blog-7.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Tree doesn't good void, waters without created",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["COMPANY", "BEAUTY"],
  },
  {
    id: 80,
    imgSrc: "/assets/images/blog/blog-8.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Given Set was without from god divide rule Hath",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["FASHION", "TRENDS"],
  },
  {
    id: 81,
    imgSrc: "/assets/images/blog/blog-9.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Tree earth fowl given moveth deep lesser After",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["STYLE", "TRENDS"],
  },
  {
    id: 82,
    imgSrc: "/assets/images/blog/blog-10.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Us yielding Fish sea night night the said him two",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["COMPANY", "BEAUTY"],
  },
];

export const blogs14 = [
  {
    id: 83,
    imgSrc: "/assets/images/blog/blog-11.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Us yielding Fish sea night night the said him two",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["COMPANY", "BEAUTY"],
  },
  {
    id: 84,
    imgSrc: "/assets/images/blog/blog-12.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Given Set was without from god divide rule Hath",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["FASHION", "TRENDS"],
  },
  {
    id: 85,
    imgSrc: "/assets/images/blog/blog-13.jpg",
    author: "By Admin",
    date: "April 05, 2023",
    title: "Woman with good shoes is never be ugly place",
    content:
      "Midst one brought greater also morning green saying had good. Open stars day let over gathered, grass face one every light of under.",
    category: ["STYLE", "BEAUTY"],
  },
];
export const allBlogs = [
  ...blogs1,
  ...blogs2,
  ...blogs3,
  ...blogs4,
  ...blogs5,
  ...blogs6,
  ...blogs7,
  ...blogs8,
  ...blogs9,
  ...blogs10,
  ...blogs11,
  ...blogs12,
  ...blogs13,
  ...blogs14,
];
export const categories = [
  "ALL",
  "COMPANY",
  "FASHION",
  "STYLE",
  "TRENDS",
  "BEAUTY",
];
